import React, { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { Box } from '@rbilabs/components-library/build/components/layout';
import { Caption } from '@rbilabs/components-library/build/components/typography';

import { designTokens } from 'styles/constants/design-tokens';

interface IStoreActionsErrorProps {
  message: string;
}

export const StoreActionsError: FC<IStoreActionsErrorProps> = ({ message }) => {
  return (
    <Caption color="text-default">
      <Box
        align="center"
        justify="center"
        background={designTokens['background-inline-alert']}
        padding="0.40625rem 0.25rem 0.34375rem"
      >
        <Icon height="0.875rem" aria-hidden color="text-default" icon="error" width="0.875rem" />
        <Box minWidth="0.25rem" width="0.25rem" maxWidth="0.25rem" />
        <span>{message}</span>
      </Box>
    </Caption>
  );
};
